<template>
    <div>
        <div>
            <h6 class="col-12 text-uppercase text-center bg-light p-2 mb-3">
                {{ label }}
            </h6>
        </div>
        <div>
            <draggable
                :key="contentKey"
                :list="value"
                handle=".handle"
                @start="drag = true"
                @end="onMoved"
            >
                <div v-for="(item, index) in content" :key="index" class="my-1">
                    <div class="mb-2">
                        <button
                            class="handle btn btn-danger waves-effect waves-light mr-1"
                            type="button"
                        >
                            <i class="fas fa-arrows-alt" />
                        </button>
                        <button
                            v-if="index"
                            class="btn btn-danger waves-effect waves-light mr-1"
                            type="button"
                            @click="moveElement(index, index - 1)"
                        >
                            <i class="fas fa-arrow-up" />
                        </button>
                        <button
                            v-if="index !== value.length - 1"
                            class="btn btn-danger waves-effect waves-light mr-1"
                            type="button"
                            @click="moveElement(index, index + 1)"
                        >
                            <i class="fas fa-arrow-down" />
                        </button>
                        <button
                            class="btn btn-danger waves-effect waves-light mr-1"
                            type="button"
                            @click="deleteElement(index)"
                        >
                            <i class="far fa-trash-alt" />
                        </button>
                    </div>
                    <component
                        :is="`content-section-${item.key}`"
                        v-model="item.value"
                        alignment-option
                        @input="$emit('input', content)"
                    />
                    <h6 class="col-12 text-uppercase bg-light p-2" />
                </div>
            </draggable>
        </div>
        <div class="mt-2">
            <div class="col-12 d-flex flex-wrap justify-content-around mb-3">
                <button
                    v-for="component in components"
                    v-show="contentSections[component]"
                    :key="component"
                    class="btn btn-success waves-effect waves-light mr-1 content-button mt-1"
                    type="button"
                    @click="addContent(component)"
                >
                    <i class="fas fa-plus-circle" /> {{ formatText(component) }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { startCase } from 'lodash';
import Draggable from 'vuedraggable';
import Text from './elements/Text';
import Image from './elements/Image';
import Video from './elements/Video';
import Header from './elements/Header';
import Gallery from './elements/Gallery';
import Audio from './elements/Audio';
import Pdf from './elements/Pdf';
import Form from './elements/Form';
import Hidden from './elements/Hidden';
import Double from './elements/Double';

export default {
    components: {
        Draggable,
        'content-section-header': Header,
        'content-section-image': Image,
        'content-section-text': Text,
        'content-section-video': Video,
        'content-section-gallery': Gallery,
        'content-section-audio': Audio,
        'content-section-pdf': Pdf,
        'content-section-form': Form,
        'content-section-hidden': Hidden,
        'content-section-double': Double
    },

    props: {
        value: {
            type: Array,
            required: true
        },
        label: {
            type: String,
            required: false,
            default: 'Content'
        },
        sections: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },

    data() {
        return {
            drag: false,
            content: [],
            contentKey: 0,
            components: [
                'header',
                'text',
                'image',
                'gallery',
                'video',
                'audio',
                'pdf',
                'form',
                'hidden',
                'double'
            ]
        };
    },

    computed: {
        contentSections() {
            return {
                header: true,
                text: true,
                image: true,
                video: true,
                gallery: true,
                form: true,
                audio: false,
                pdf: false,
                hidden: false,
                double: false,
                ...this.sections
            };
        },

        isHiddenAdded() {
            if (!this.contentSections.hidden) {
                return true;
            }

            return this.content.some(item => item.key === 'hidden');
        }
    },

    created() {
        this.content = [...this.value];
    },

    methods: {
        addContent(type) {
            let value = {};

            if (type === 'gallery') {
                value = [];
            } else if (type === 'header' || type === 'text') {
                value = '';
            } else if (type === 'video') {
                value.linkOnly = true;
            } else if (type === 'form') {
                value = null;
            } else if (type === 'hidden' && this.isHiddenAdded) {
                return this.$toaster('You can add only one Hidden Component.', {
                    title: 'Warning!',
                    variant: 'warning'
                });
            } else if (type === 'double') {
                value = {
                    left: [],
                    right: []
                };
            }

            const newItem = {
                key: type,
                value
            };

            this.content = [...this.content, { ...newItem }];

            this.$emit('input', this.content);
            this.contentKey += 1;
        },

        moveElement(from, to) {
            this.content.splice(to, 0, this.content.splice(from, 1)[0]);

            this.$emit('input', [...this.content]);
            this.contentKey += 1;
        },

        onMoved() {
            this.drag = false;
            this.contentKey += 1;
        },

        deleteElement(index) {
            this.content.splice(index, 1);

            this.$emit('input', [...this.content]);
            this.contentKey += 1;
        },

        formatText(value) {
            return startCase(value);
        }
    }
};
</script>
